import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../api";

const BetaContext = createContext(null);

const GUIDANCE_DISMISSED_KEY = "ff_guidance_dismissed";
const FIRST_EXPEDITION_KEY = "ff_first_expedition_done";

export function BetaProvider({ children }) {
  const [onboarding, setOnboarding] = useState(null); // null = loading
  const [guidanceDismissed, setGuidanceDismissed] = useState(
    () => localStorage.getItem(GUIDANCE_DISMISSED_KEY) === "1"
  );
  const [firstExpeditionDone, setFirstExpeditionDone] = useState(
    () => localStorage.getItem(FIRST_EXPEDITION_KEY) === "1"
  );
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  const refresh = useCallback(() => {
    return api
      .get("/beta/onboarding")
      .then((r) => setOnboarding(r.data))
      .catch(() => setOnboarding({ eligible: false, seen: true }));
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const updateOnboarding = async (payload) => {
    const { data } = await api.put("/beta/onboarding", payload);
    setOnboarding(data);
    return data;
  };

  const dismissGuidance = () => {
    localStorage.setItem(GUIDANCE_DISMISSED_KEY, "1");
    setGuidanceDismissed(true);
  };

  const markFirstExpeditionDone = () => {
    localStorage.setItem(FIRST_EXPEDITION_KEY, "1");
    setFirstExpeditionDone(true);
  };

  // Guidance shows only for eligible real beta players who have neither finished their
  // first expedition nor dismissed the coach marks.
  const guidanceActive = !!(onboarding && onboarding.eligible) && !firstExpeditionDone && !guidanceDismissed;

  const value = {
    onboarding,
    refresh,
    updateOnboarding,
    guidanceActive,
    dismissGuidance,
    markFirstExpeditionDone,
    feedbackOpen,
    openFeedback: () => setFeedbackOpen(true),
    closeFeedback: () => setFeedbackOpen(false),
  };
  return <BetaContext.Provider value={value}>{children}</BetaContext.Provider>;
}

export const useBeta = () => useContext(BetaContext) || {};
